import * as React from 'react';

import { Dropdown } from '@process-advisor/process-miner/components/shared/dropdown';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';

const options = [
    { value: '5pt', label: 'Very Small' },
    { value: '6pt', label: 'Small' },
    { value: '7pt', label: 'Normal' },
    { value: '8pt', label: 'Large' },
    { value: '9pt', label: 'Very Large' },
];

export const NodeLabelFontSize = () => {
    const [value, setValue] = React.useState<string>('6pt');

    const onChange = (value: string) => {
        setValue(value);
        apiProvider.changeNodeLabelFontSize({ font_size: value });
        apiProvider.rebuildPVDiagram({});
    };

    React.useEffect(() => {
        setValue(apiProvider.getNodeLabelFontSize().font_size);
    }, []);

    React.useEffect(() => {
        const listener = () => {
            const settings = apiProvider.getNodeLabelFontSize();
            setValue (settings.font_size);
        };

        apiProvider.on(Event.loadProcessMinerSettings, listener);

        return () => {
            apiProvider.off(Event.loadProcessMinerSettings, listener);
        };
    }, []);

    return (
        <Dropdown
            options={options}
            onChange={onChange}
            value={value} />
    );
};
